/*eslint-disable*/

import logger from "../../console";
import { redirect, ServerOnly, TokenResolver } from "@/lib/serverOnly";
import categories from "@/lib/path-resolver-middlewares/ssr/categories";

export function InitialResolver(...fns) {
  return function (ctx) {
    ctx.path = {
      categoriesDictionary: categories,
    };
    ctx?.res?.setHeader("Link", `<https://images.aqar.fm>; rel="preconnect"`);
    ctx.performance = {
      requestStart: Date.now(),
    };

    ctx.redirect = (url) => redirect(url, ctx);
    return new Promise(async (resolve, reject) => {
      let circuitBreaker = false;
      let output = {};
      const middlewares = [
        ServerOnly(),
        async (ctx) => {
          ctx.appState = {
            isMapPage: false,
            isDailyRentPage: false,
            isRedMode: false,
            msgsCount: 0,
            chartJSLoaded: false,
            isMobile: false,
            layout: "",
          };
          if (
            ctx.req.headers["user-agent"]?.includes("iPhone") ||
            ctx.req.headers["user-agent"]?.includes("Android")
          ) {
            ctx.appState.isMobile = true;
          }
        },
        TokenResolver(),
        ...fns,
      ];
      for (let i = 0; i < middlewares.length; i++) {
        if (typeof middlewares[i] !== "function") {
          return reject(
            new Error(`Function at ${i} doesn't return a function`),
          );
        }
        try {
          output = await middlewares[i](
            ctx,
            /**
             * this is the res function call it to stop execution of the next
             * middleware and return props
             * */
            function res(dt) {
              circuitBreaker = true;
              resolve({
                ...dt,
                errors: ctx.errors,
                authState: ctx?.authState,
                performance: ctx.performance,
                appState: ctx?.appState,
                path: ctx?.path,
              });
            },
          );
        } catch (error) {
          circuitBreaker = true;
          resolve({
            ...output,
            error,
            authState: ctx?.authState,
            performance: ctx.performance,
            path: {
              ...ctx?.path,
              error,
            },
            appState: ctx?.appState,
          });
          break;
        }
        if (circuitBreaker) {
          ctx.performance.requestEnd = Date.now();
          ctx.performance.reqeustTook =
            ctx.performance.requestEnd - ctx.performance.requestStart;
          return;
        }
      }

      // return last function output if not circuitBroke;
      logger.log("Resolved", output);
      ctx.performance.requestEnd = Date.now();

      ctx.performance.reqeustTook =
        ctx.performance.requestEnd - ctx.performance.requestStart;
      resolve({
        ...output,
        performance: ctx.performance,
        errors: ctx.errors,
        authState: ctx?.authState,
        path: ctx?.path,
        appState: ctx?.appState,
      });
    });
  };
}
